import React from "react";
import GrievanceBot from "../components/dashboard/GrievanceBot";
import waterDropLogo from "../assets/images/logo.png";
import bgImage from "../assets/images/bg.png";
import sidebarImage from "../assets/images/Rectangle 5191.png";
import dashboardIcon2 from "../assets/images/grid-view2.png";
import { useNavigate } from "react-router-dom";

// main component of app
// default ui component for home page
function BotDesk() {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate("/desk");
  };
  const handleNewChat = () => {
    navigate(0);
  };

  return (
    <div className="flex-1 flex flex-col overflow-hidden">

      {/* Mobile Top Navigation */}
      <div className="flex sm:hidden w-full bg-[#F3F8FF] border-b border-[#E7E5E4] px-4 py-2 gap-3 justify-between overflow-x-auto shrink-0">
        <button
          onClick={handleBackClick}
          className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold shrink-0 whitespace-nowrap bg-gradient-to-r from-[#45B07B] to-[#12A57C] text-white"
        >
          <img src={dashboardIcon2} alt="" className="w-4 h-4" />
          Dashboard
        </button>
        <button
          className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold shrink-0 whitespace-nowrap bg-white text-black border border-[#E7E5E4]"
          onClick={handleNewChat}
        >
          <img alt="logo" src={waterDropLogo} className="w-4 h-4 shrink-0" />
          Lodge Grievance
        </button>
      </div>

      {/* Desktop row: sidebar + content */}
      <div className="flex-1 flex overflow-hidden bg-[#F3F8FF]">
        <div className="hidden sm:flex flex-col w-[15%] min-w-[150px] bg-white border-r-[0.8px] border-[#E7E5E4] shadow-[inset_0px_4px_4px_rgba(0,0,0,0.25)] pt-4 px-3 pb-3 shrink-0 justify-between h-full overflow-y-auto">
          <div className="flex flex-col gap-3 w-full">
            <button
              onClick={handleBackClick}
              className="mt-1 w-full h-[40px] rounded-[12px] py-[8px] gap-[10px] bg-gradient-to-r from-[#45B07B] to-[#12A57C] shadow-[0_4px_4px_0_rgba(0,0,0,0.25)] flex flex-row items-center justify-center text-white font-semibold text-[13px] cursor-pointer"
            >
              <img src={dashboardIcon2} alt="dashboard" className="w-[18px] h-[18px] object-cover" />
              Dashboard
            </button>

            <div className="w-[calc(100%+24px)] h-[1px] bg-[#E5E7EB] -ml-[12px]" />

            <button
              className="w-full h-[40px] rounded-[12px] py-[8px] gap-[10px] bg-gradient-to-r from-[#45B07B] to-[#12A57C] shadow-[0_4px_4px_0_rgba(0,0,0,0.25)] flex flex-row items-center justify-center text-white font-medium text-[13px] cursor-pointer"
              onClick={handleNewChat}
            >
              <img alt="bihar_logo" src={waterDropLogo} className="w-5 h-5 shrink-0" />
              Lodge Grievance
            </button>
          </div>

          <div className="flex flex-col items-center mt-8">
            <img src={sidebarImage} alt="Powered by Innovation" className="w-full max-w-[200px] h-auto opacity-70 object-contain mb-2" />
            <div className="w-[calc(100%+24px)] min-h-[40px] flex items-center justify-center -mx-[12px]">
              <p className="font-['Inter'] font-medium text-[10px] leading-[16px] text-center text-[#0000006E]">
                © Site developed and maintained by KPMG Advisory Services Pvt. Ltd.
              </p>
            </div>
          </div>
        </div>
        <GrievanceBot />
      </div>
    </div>
  );
}

export default BotDesk;
